<div
    class="w-50 mt-4 masonry-item flex-card clip6 position-relative prop-card fw-normal primary-border rounded-1 clip6-corner">
    <h6 class="mb-4 primary-text">Unable to load data. Please contact support if the issue persists.</h6>
</div>